import { Component, computed, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { TranslocoPipe } from '@ngneat/transloco';
import { ModalName, ModalService } from '../../core/services/modal.service';

@Component({
  selector: 'cwo-coupon-input',
  standalone: true,
  imports: [FormsModule, CommonModule, TranslocoPipe],
  templateUrl: './coupon-input.component.html',
  styleUrl: './coupon-input.component.scss',
})
export class CouponInputComponent {
  private modalService = inject(ModalService);

  isInValid = input<boolean>();
  disabled = input<boolean>(false);
  isPrimary = input<boolean>(true);
  isOnModal = computed(() => this.modalService.isModalOpen(ModalName.Cart));
  
  readonly formSubmitted = output<string>();
  couponValue: string = '';
  couponValueChange = new Subject<string>();

  handleSubmit(): void {
    this.formSubmitted.emit(this.couponValue);
    this.couponValue = '';
  }
}
